import React from 'react';
import PropTypes from 'prop-types';
import AccountTypeCard from '../AccountTypeCard';
import { TextBody } from 'web-ui-components/lib/atoms/text';
import { Card } from 'web-ui-components/lib/organisms/cards';
import { getCustomerNumberInfoText } from '../../businessLogic/AccountsBL';

const TransactionStaticCard = ({ accountDetails, content, userPhoneNumber }) => {
  const { transactionAlertsHeader, transactionInfoText, alertLandingPageInfo } = content;
  return (
    <div className="u-component-spacing">
      <AccountTypeCard accountDetails={accountDetails} />
      <TextBody>
        <p>{transactionAlertsHeader}</p>
      </TextBody>
      <Card type="info" bordered>
        {transactionInfoText} <br />
        <div className="u-padding-top-1" />
        {getCustomerNumberInfoText(alertLandingPageInfo, userPhoneNumber)}
      </Card>
    </div>
  );
};

TransactionStaticCard.propTypes = {
  accountDetails: PropTypes.shape({}),
  content: PropTypes.shape({}),
  userPhoneNumber: PropTypes.array,
};
export default TransactionStaticCard;
